// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Profile from './Profile';
import Notification from './Notification'; // admin
import NotificationCollaborator from './NotificationCollaborator'; // 👈 nuevo
import MobileSection from './MobileSection';

// auth
import { useAuth } from '@/auth/AuthContext';

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { user, loading } = useAuth();

  const role = String(user?.role || '').toLowerCase();
  const isAdmin = !loading && ['admin', 'administrador', 'administrator'].includes(role);
  const isCollaborator = !loading && ['collaborator', 'colaborador'].includes(role);

  return (
    <>
      <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }} />
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      {isAdmin && <Notification />}
      {!isAdmin && isCollaborator && <NotificationCollaborator />}

      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
